import {useCallback, useState} from "react";
import {GET_SELECTED_SHOP_ID, REQUEST} from "../../../../utils/js/Const";
import {useNavigate} from "react-router-dom";
import {FetchElements, GetCookie} from "../../../../utils/js/request";

export const useGetOrderGroupDetails = () => {

    const navigate = useNavigate();

    const [orderGroupDetails, setOrderGroupDetails] = useState([])
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchOrderGroupDetails = useCallback(async (statuses_id) => {

        const selectedId = GET_SELECTED_SHOP_ID();
        const accessToken = GetCookie("access_token");

        if (selectedId === 0 || !accessToken) {
            console.warn('Нет данных для запроса о группах');
            return null;
        }

        const url = `${REQUEST}/api/v1/orders/statuses/${statuses_id}?shops_id=${selectedId}`;
        setLoading(true);
        setError(null);

        FetchElements(
            url,
            "GET",
            (responseData) => {
                const details = responseData?.data || responseData || [];
                setOrderGroupDetails(Array.isArray(details) ? details : []);
                setLoading(false);
            },
            navigate,
            2,
            () => {},
            (title, message, statusCode) => {
                const errorObj = {title, message, statusCode};
                console.error(`${title}: ${message}`);
                setError(errorObj);
                setOrderGroupDetails([]);
                setLoading(false);
            },
            0,
            null,
            [],
            false
        );
    }, [navigate])


    return {
        refetch: fetchOrderGroupDetails,
        orderGroupDetails,
        loading,
        error,
        fetchOrderGroupDetails,
    };

}